import {TweenMax, TimelineLite, Linear, Power0, Power1, Power2, TimelineMax} from 'gsap/TweenMax'
import CustomEase from './CustomEase'
import Vue from 'vue'

export default () => {
  Vue.prototype.$gsap = {
    TweenMax,
    TimelineLite,
    TimelineMax,
    Linear,
    Power2,
    Power1,
    Power0,
    CustomEase
  }
}
